import { render, staticRenderFns } from "./InsuranceRiskPaymentList.vue?vue&type=template&id=689d21d8&"
import script from "./InsuranceRiskPaymentList.vue?vue&type=script&lang=js&"
export * from "./InsuranceRiskPaymentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports